import { useState } from 'react'
import type SwiperCore from 'swiper'
import { A11y } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { SectionEyebrow } from '#app/shared/ui/data-display/SectionEyebrow.tsx'
import { Icon } from '#app/shared/ui/icons/Icon.tsx'
import { MainContainer } from '#app/shared/ui/layout/MainContainer.tsx'
import 'swiper/swiper-bundle.css'

const SHOWROOM_IMAGES = [
  '/img/sobreNosotros/carousel/2.jpg',
  '/img/sobreNosotros/carousel/3.jpg',
  '/img/sobreNosotros/carousel/4.jpg',
  '/img/sobreNosotros/carousel/5.jpg',
  '/img/sobreNosotros/carousel/6.jpg',
  '/img/sobreNosotros/carousel/7.jpg',
  '/img/sobreNosotros/carousel/8.jpg',
  '/img/sobreNosotros/carousel/9.jpg',
  '/img/sobreNosotros/carousel/10.jpg',
  '/img/sobreNosotros/carousel/11.jpg',
  '/img/sobreNosotros/carousel/12.jpg',
  '/img/sobreNosotros/carousel/13.jpg',
  '/img/sobreNosotros/carousel/14.jpg',
  '/img/sobreNosotros/carousel/15.jpg',
]

export const Showroom = () => {
  const [swiper, setSwiper] = useState<SwiperCore | undefined>(undefined)

  return (
    <section
      className={`
        py-16

        lg:py-20
      `}
    >
      <MainContainer
        className={`
          px-4

          sm:px-6
        `}
      >
        <SectionEyebrow>Nuestro showroom</SectionEyebrow>
        <h2
          className={`
            mb-3 text-h3 text-primary-800

            lg:text-h2
          `}
        >
          Un espacio pensado para decidir
        </h2>
        <p className="mb-10 text-base-medium text-neutral-600">
          Más de 1.000 m² en Les Tres Torres (Sarrià–Sant Gervasi) dedicados
          íntegramente a la experiencia de compra.
        </p>
      </MainContainer>

      <div className="relative w-full overflow-hidden">
        <Swiper
          modules={[A11y]}
          slidesPerView="auto"
          centeredSlides
          loop
          spaceBetween={16}
          onSwiper={setSwiper}
          className="!overflow-visible"
        >
          {SHOWROOM_IMAGES.map((src, i) => (
            <SwiperSlide
              key={i}
              className={`
                !w-[260px]

                lg:!w-[600px]

                sm:!w-[440px]

                xl:!w-[1000px]
              `}
            >
              <img
                src={src}
                alt={`Showroom ${i + 1}`}
                width={1000}
                height={681}
                className="aspect-[880/599] w-full rounded-lg object-cover"
                loading="lazy"
              />
            </SwiperSlide>
          ))}
        </Swiper>

        <button
          type="button"
          aria-label="Anterior"
          onClick={() => swiper?.slidePrev()}
          className={`
            absolute left-3 top-1/2 z-10 flex h-9 min-h-9 w-9 min-w-9
            -translate-y-1/2 cursor-pointer items-center justify-center
            rounded-full border border-neutral-100 bg-white

            sm:left-6
          `}
        >
          <Icon
            size="12px"
            name="basic/chevron-left"
            className="pointer-events-none text-neutral-300"
          />
        </button>

        <button
          type="button"
          aria-label="Siguiente"
          onClick={() => swiper?.slideNext()}
          className={`
            absolute right-3 top-1/2 z-10 flex h-9 min-h-9 w-9 min-w-9
            -translate-y-1/2 cursor-pointer items-center justify-center
            rounded-full border border-neutral-100 bg-white

            sm:right-6
          `}
        >
          <Icon
            size="12px"
            name="basic/chevron-right"
            className="pointer-events-none text-neutral-300"
          />
        </button>
      </div>
    </section>
  )
}
